import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import FailureAlert from '../Common/Failure';
import QRCode from 'qrcode.react';
import { Helmet } from "react-helmet";
import IDCardTheme from '../../Images/IDCardTheme.png';
import IDCardUser from '../../Images/IDCard_User.png';
import { FetchUsers } from '../Common/Services/UserService';

import moment from 'moment';

const AppMetaHeader = {
    title: "Accredited and Verified Movers",
    description: "MFI (Movers Federation of India) is India's Largest forum of Pre-own and managed relocation companies",
    keywords: "packer and movers ,logistics ,packers ,movers, MFI ,mfi packers ,mfi movers ,movers in india, packers in india",
    site_name: "MFI Packers and Movers",
    url: "app.mfind.net/",
    type: "business.business"
}

const UserVerification = () => {

    var { id } = useParams();
    const [SelectedUsers, setSelectedUsers] = useState({});

    useEffect(() => {
        FetchUser(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchUser = (userid) => {
        if (id !== undefined && id !== null && id !== "") {
            FetchUsers({ _id: userid }, UserSuccess, Failure);
        }
    };

    const UserSuccess = (data) => {
        if (data.length > 0) {
            setSelectedUsers(data[0]);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Helmet>
                <meta property="title" content={AppMetaHeader.title} />
                <meta property="og:title" content={AppMetaHeader.title} />
                <meta name="description" content={AppMetaHeader.description} />
                <meta name="og:description" content={AppMetaHeader.description} />
                <meta name="keyword" content={AppMetaHeader.keywords} />
                <meta property="og:site_name" content={AppMetaHeader.title} />
                <meta property="og:image" content={IDCardUser} />
                <meta
                    property="og:url"
                    content={`${window.location.hostname}/UserVerification/606694d1f6ac330730ff8c01}`}
                />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>
            <div className="container-fluid">
                <div className="col-md-12 align-center">
                    <h2 style={{ backgroundColor: "#005582", marginTop: "10px", padding: "10px", color: "white", border: "1px solid #ccc", borderRadius: "6px" }}>User verification</h2>
                </div>

                {SelectedUsers._id !== undefined && SelectedUsers._id !== "" && (
                    <div className="row" style={{ justifyContent: "center", paddingTop: "40px" }}>
                        <div id="IDCard" style={{ border: "1px solid #ccc", borderRadius: "10px" }}>
                            <div style={{ height: "70vh", width: "300px", backgroundPosition: "bottom", borderRadius: "15px", backgroundSize: "cover", backgroundImage: ('url(' + IDCardTheme + ')') }}>
                                {SelectedUsers.ExpiryDate && (<div className="validTill">
                                    <span className="validTillText">Valid Till : {moment(SelectedUsers.ExpiryDate).local().format("MMM YYYY")}</span>
                                </div>)}
                                <div style={{ backgroundColor: "#005582", width: "100%", marginTop: "5px", height: "50px" }}>
                                    <div>
                                        {(SelectedUsers.Organization && SelectedUsers.Organization.length > 0) && (<div style={{ color: "white", paddingTop: "7px", fontSize: "20px", textAlign: "center", width: "100%" }}> MFI {SelectedUsers.Organization[0].City}</div>)}
                                    </div>
                                </div>
                                <div style={{ textAlign: "right", margin: "15px" }}>
                                    <QRCode renderAs="svg" bgColor={'white'} size={80}
                                        includeMargin={false} level="M"
                                        value={SelectedUsers._id.toString()} />
                                </div>
                                <div style={{ fontSize: "14px" }}>
                                    <div style={{ marginTop: "5px" }}>
                                        <div className="IDCardStyle" style={{
                                            backgroundColor: "white", margin: "0 10px"
                                        }}>{SelectedUsers._id}</div>
                                    </div>
                                    <div style={{ marginTop: "5px" }}>
                                        <table className="table" style={{
                                            textAlign: "center", borderCollapse: "separate",
                                            borderSpacing: "0 6px"
                                        }}>
                                            <tbody style={{ color: "white", textTransform: "uppercase" }}>
                                                <tr>
                                                    <td style={{ width: "30%", borderRadius: "0 25px 25px 0", backgroundColor: "#005582" }}>Company</td>
                                                    <td style={{ width: "1%" }}></td>
                                                    <td style={{ borderRadius: "25px 0 0 25px", backgroundColor: "#005582" }}>
                                                        <div title={SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && SelectedUsers.Organization[0].Name}
                                                            style={{ width: "155px", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
                                                            {SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && SelectedUsers.Organization[0].Name}
                                                        </div></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: "30%", borderRadius: "0 25px 25px 0", backgroundColor: "#005582" }}>NAME</td>
                                                    <td style={{ width: "1%" }}></td>
                                                    <td style={{ borderRadius: "25px 0 0 25px", backgroundColor: "#005582" }}>
                                                        <div> {SelectedUsers.FirstName + " " + SelectedUsers.LastName}</div></td>
                                                </tr>
                                                {SelectedUsers.Organization.length > 0 && (<tr>
                                                    <td style={{ width: "30%", borderRadius: "0 25px 25px 0", backgroundColor: "#005582" }}>GSt</td>
                                                    <td style={{ width: "1%" }}></td>
                                                    <td style={{ borderRadius: "25px 0 0 25px", backgroundColor: "#005582" }}>
                                                        <div>{SelectedUsers.Organization[0].GSTNumber}</div></td>
                                                </tr>)}
                                                <tr>
                                                    <td style={{ width: "30%", borderRadius: "0 25px 25px 0", backgroundColor: "#005582" }}>CONTACT</td>
                                                    <td style={{ width: "1%" }}></td>
                                                    <td style={{ borderRadius: "25px 0 0 25px", backgroundColor: "#005582" }}>
                                                        <div>{SelectedUsers.PhoneNumber}</div></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="IDCardWebSiteName" style={{ cursor: "default" }}>
                                        <span>app.mfind.net</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-3" id="IDCard" style={{ position: "relative" }}>
                            <img alt="logo" style={{ borderRadius: "10px" }} width="320px" src={IDCard}></img>
                            <img alt="logo" style={{ position: "absolute", left: "16%", top: "10px" }} width="90" src={Verification}></img>
                            <div style={{ position: "absolute", color: "#005582", top: "70px", left: "70%", fontSize: "50px" }}>
                                <FontAwesomeIcon icon={faUserTie} />
                            </div>
                            <div style={{ position: "absolute", top: "160px", left: "6%", fontSize: "14px", width: "90%" }}>
                                <div style={{marginTop:"10px"}}>
                                    <span className="IDCardStyle" style={{ textTransform: "uppercase" }}>{SelectedUsers._id}</span>
                                </div>
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "100px" }}>NAME</td>
                                            <td>
                                                <span style={{ textTransform: "uppercase" }}>: {SelectedUsers.FirstName + " " + SelectedUsers.LastName}</span></td>
                                        </tr>
                                        {SelectedUsers.Organization.length > 0 && (<tr>
                                            <td>ORG</td>
                                            <td><span style={{ textTransform: "uppercase" }}>: MFI {SelectedUsers.Organization[0].City}</span></td>
                                        </tr>)}
                                        <tr>
                                            <td>CONTACT</td>
                                            <td><span>: {SelectedUsers.PhoneNumber}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div>
                                <div style={{ position: "absolute", bottom: "30px", left: "5%" }}>
                                    <QRCode renderAs="svg" bgColor={'transparent'} size={85}
                                        includeMargin={true} level="M"
                                        value={SelectedUsers._id.toString()} />
                                </div>
                            </div>
                            <div className="IDCardWebSiteName">www.moversfederation.org</div>
                        </div> */}
                    </div>)}
            </div>
        </div>
    );
};

export default UserVerification;